import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheckCircle,
  faCircleExclamation,
  faCircleInfo,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";

const ToastContext = createContext(null);
export function ToastProvider({ children }) {
  const [items, setItems] = useState([]);
  const remove = useCallback(
    (id) => setItems((list) => list.filter((item) => item.id !== id)),
    [],
  );
  const show = useCallback(
    (message, type = "success") => {
      const id = Date.now() + Math.random();
      setItems((list) => [...list, { id, message, type }]);
      setTimeout(() => remove(id), 4500);
    },
    [remove],
  );
  const value = useMemo(() => ({ show }), [show]);
  const icons = {
    success: faCheckCircle,
    error: faCircleExclamation,
    info: faCircleInfo,
  };
  return (
    <ToastContext.Provider value={value}>
      {children}
      <div className="toast-stack" aria-live="polite">
        {items.map((item) => (
          <div key={item.id} className={`toast toast-${item.type}`}>
            <FontAwesomeIcon icon={icons[item.type] || icons.info} />
            <span>{item.message}</span>
            <button
              aria-label="Dismiss notification"
              onClick={() => remove(item.id)}
            >
              <FontAwesomeIcon icon={faXmark} />
            </button>
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  );
}
export const useToast = () => useContext(ToastContext);
